const offScreenCanvas = document.createElement('canvas');
const innerOffScreenCanvas = document.createElement('canvas');
const foreheadCanvas = document.createElement('canvas');

export function captureFrame(video) {
    if (!video.videoWidth || !video.videoHeight) return null;
    offScreenCanvas.width = video.videoWidth;
    offScreenCanvas.height = video.videoHeight;

    let ctx = offScreenCanvas.getContext('2d', {willReadFrequently: true});
    ctx.drawImage(video, 0, 0, offScreenCanvas.width, offScreenCanvas.height);
    return offScreenCanvas;
}

export function captureImage(image) {
    if (!image.naturalWidth || !image.naturalHeight) return null;
    offScreenCanvas.width = image.naturalWidth;
    offScreenCanvas.height = image.naturalHeight;

    let ctx = offScreenCanvas.getContext('2d', {willReadFrequently: true});
    ctx.drawImage(image, 0, 0, offScreenCanvas.width, offScreenCanvas.height);
    return offScreenCanvas;
}

export function captureBoxFromFrame(frameImage, box) {
    if (!frameImage.width || !frameImage.height) return null;
    innerOffScreenCanvas.width = box.width;
    innerOffScreenCanvas.height = box.height;

    // let increasedBox = increaseBoxSize(box, 50);
    // let ctx = innerOffScreenCanvas.getContext('2d', {willReadFrequently: true});
    // ctx.drawImage(frameImage, 0, 0, innerOffScreenCanvas.width, innerOffScreenCanvas.height);
    // ctx.getImageData(increasedBox.x, increasedBox.y, increasedBox.width, increasedBox.height);

    //cut the box from the frame and draw it on the innerOffScreenCanvas
    let ctx = innerOffScreenCanvas.getContext('2d', {willReadFrequently: true});
    ctx.drawImage(frameImage, box.x, box.y, box.width, box.height, 0, 0, box.width, box.height);

    //print the image canvas on an image under the body tag
    /* let img = new Image();
     img.src = innerOffScreenCanvas.toDataURL();
     // set image width, height and zIndex
     img.style.width = innerOffScreenCanvas.width + "px";
     img.style.height = innerOffScreenCanvas.height + "px";
     img.style.zIndex = "1000";
     img.style.position = "absolute";
     img.style.top = "0";
     img.style.left = "0";

     document.body.appendChild(img);*/

    return innerOffScreenCanvas;
}

export function getBoxImgData(box) {
    return offScreenCanvas.getContext('2d').getImageData(box.x, box.y, box.width, box.height);
}

export function drawForeheadRegion(frame, foreheadRegion) {
    let ctx = foreheadCanvas.getContext('2d', {willReadFrequently: true});
    ctx.drawImage(
        frame,
        foreheadRegion.x,
        foreheadRegion.y,
        foreheadRegion.width,
        foreheadRegion.height,
        0,
        0,
        foreheadCanvas.width,
        foreheadCanvas.height
    );

    const imageData = ctx.getImageData(0, 0, foreheadCanvas.width, foreheadCanvas.height);
    return imageData;
}
